import { INavigation } from '@/store/modules/groupManagement/types';

export const initNavigationData: INavigation = {
  start: 0,
  groupsPerPage: 20,
  direction: 'forward',
  isLastGroupPage: false
};

export default initNavigationData;
